import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ytb-container"
};
import { computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from 'pinia';
import YtbAccessDialog from '@/components/corp/ytb/YtbAccessDialog.vue';
import { useYtbAccessStore } from '@/stores/modules/ytb-access.store.js';
export default {
  __name: 'YtbRootLayout',
  setup(__props) {
    const route = useRoute();
    const accessStore = useYtbAccessStore();
    const {
      authorized,
      checked
    } = storeToRefs(accessStore);
    const ytbMode = computed(() => route.meta.ytbMode || 'page');
    const keepAlive = computed(() => route.meta.ytbKeepAlive === true);
    /** 子页须等 status 检查完成且已解锁后再挂载，避免未授权时业务 API 401 冒泡 */
    const canRenderPage = computed(() => {
      if (!route.meta.ytbAccess) return true;
      return checked.value && authorized.value;
    });
    onMounted(async () => {
      accessStore.init();
      await accessStore.ensureForSubPage(route);
    });
    watch(() => route.fullPath, async () => {
      await accessStore.ensureForSubPage(route);
    });
    return (_ctx, _cache) => {
      const _component_RouterView = _resolveComponent("RouterView");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["ytb-bg-pattern", {
          'ytb-bg-pattern--home': ytbMode.value === 'home'
        }])
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(["ytb-content", {
          'ytb-content--home': ytbMode.value === 'home'
        }])
      }, [canRenderPage.value && !keepAlive.value ? (_openBlock(), _createBlock(_component_RouterView, {
        key: _unref(route).fullPath
      })) : canRenderPage.value ? (_openBlock(), _createBlock(_component_RouterView, {
        key: 1
      }, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(route).fullPath
        }))], 1024))]),
        _: 1
      })) : _createCommentVNode("", true)], 2), _createVNode(YtbAccessDialog)]);
    };
  }
};